import { EntryDateIndex } from "reducers/postReducer"

export const arrayRemove = <T>(arr: T[], value: any) => {
  return arr.filter((ele) => {
    return ele != value
  })
}

export const removeEntryFromArrayById = (arr: EntryDateIndex[], idToRemove: string) => {
  return arr.filter((ele) => {
    return ele.entryId !== idToRemove
  })
}

export const removeEntriesFromArrayById = (arr: EntryDateIndex[], idToRemove: string[]) => {
  return arr.filter((ele) => {
    return !idToRemove.includes(ele.entryId)
  })
}

export const arraySortByDate = (arr: any[]) => {
  return arr.sort(function (a: any, b: any) {
    return a.createdAt - b.createdAt;
  });
}